module.exports = __webpack_public_path__ + "img/Wp_2081.ce7eeb24.png";